import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface BorderProps {
	borderWidth: number;
	isActive: boolean;
}

const StyledIframeEditor = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	pointer-events: auto;

	iframe {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 100%;
		border: 0;
		pointer-events: none;
	}
`;

const Border = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	border: ${({ borderWidth }: BorderProps) => `${borderWidth}px`}
		solid
		${({ isActive }: BorderProps) => isActive ? `${NewStyleColor.Blue100}` : `${NewStyleColor.Grey400}`};
	border-radius: inherit;
`;

export {
	StyledIframeEditor,
	Border,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/IframeEditor/styles.ts